export function Loading({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="center-page">
      <div style={{ display: "grid", placeItems: "center", gap: 12 }}>
        <div className="spinner" />
        <div className="muted" style={{ fontSize: 13 }}>
          {label}
        </div>
      </div>
    </div>
  );
}
